import React from 'react';
import { useSelector } from 'react-redux';
import { useState } from 'react';

import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import Image from '../../components/Image/Image';
import loadable from '@loadable/component';
import Button from '../../components/form-elements/Button';
import LegacyShopWrapper from '../../LegacyShopWrapper';
import Modal from '../../components/Modal/Modal'

// TODO: use new Modal component

const ServiceStationFinder = loadable(() => import('../../components/ServiceStationFinder/ServiceStationFinder'));

function UeberUnsOldFashion() {
    const markenStandort = useSelector(markenStandortSelector);
    const [modalOpen, setModalOpen] = useState(false);
    return (
        <>
            <LegacyShopWrapper>
                <div>
                    <div style={{ clear: 'both' }} />
                    <div className="ueber_uns_wrapper">
                        <div className="header_container">
                            <div className="headline_container">
                                <h1>
                                    <strong className="bold_headline">AUTOTEILE PLUS SERVICE -</strong>
                                    <p className="thin_headline">
                                        EIN ANGEBOT VON{' '}
                                        {markenStandort.isTechno ? (
                                            <span>DEUTSCHLANDS FÜHRENDEN AUTOHÄUSERN.</span>
                                        ) : (
                                            <span>{markenStandort.anschrift.firma}</span>
                                        )}
                                    </p>
                                </h1>
                                <h2>
                                    <strong>Unser Prinzip: Sowohl Markenwerkstatt-Vermittlung als auch Shopping!</strong>
                                </h2>
                                <div>
                                    <p className='uk-text-large'>
                                        <strong>AUTOTEILE PLUS SERVICE</strong> ist ein markenübergreifender Zusammenschluss
                                        <br /> der 150 größten Autohändler Deutschlands mit bundesweit über 1.800 Autohäusern. Bei uns können
                                        Sie Original-Ersatzteile, Zubehör oder Accessoires&nbsp;für Ihr Fahrzeug 
                                        <strong> sowohl</strong> nach Hause bestellen <strong>oder</strong> zur Abholung im nächsten Autohaus vorreservieren,
                                        <strong> als auch</strong> eine auf Ihr Fahrzeug spezialisierte&nbsp;Markenwerkstatt in Ihrer Nähe finden, Ihren
                                        Wunschtermin vereinbaren und vom fachgerechten Service zum vereinbarten Festpreis profitieren.
                                    </p>
                                </div>
                            </div>
                            <div className="image_container">
                                <Image
                                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/standort-images/${markenStandort.gesellschafterNr}/${markenStandort.standortNr}/UeberUnsMeister.png`}
                                    alt="Werkstattmeister in der Werkstatt"
                                    
                                />
                            </div>
                            <div className="clear" />
                        </div>
                        <div className="section_container">
                            <div className="heading_container">
                                <i className="fa fa-check-circle" aria-hidden="true" />
                                <p>
                                    {' '}
                                    <h2>WORAUF SIE SICH BEI <strong>AUTOTEILE PLUS SERVICE</strong> VERLASSEN KÖNNEN</h2>
                                </p>
                                <div className="clear" />
                            </div>
                            <div className="row_container">
                                <div className="content_container" id="ersatzteile">
                                    <div className="inner">
                                        <div className="image_box">
                                            <Image
                                                src={`https://techno-images.s3.eu-central-1.amazonaws.com/standort-images/${markenStandort.gesellschafterNr}/${markenStandort.standortNr}/Matrix1.jpg`}
                                                alt="Original-Ersatzteile bei AUTOTEILE PLUS SERVICE"
                                                
                                            />
                                        </div>
                                        <div className="text_box">
                                            <div className="text_inner">
                                                <p>
                                                    <strong>
                                                        IHR PLUS AN QUALITÄT:
                                                        <br />
                                                        BEI UNS - NUR 100% ORIGINAL-ERSATZTEILE.
                                                    </strong>
                                                    <br />
                                                    <br />
                                                    Bei <strong>AUTOTEILE PLUS SERVICE</strong> können Sie sich darauf verlassen, dass ausschließlich
                                                    Original-Ersatzteile vertrieben - und im Fall der Fälle eingebaut werden. Was anderes
                                                    kommt bei Deutschlands führenden Autohäusern nicht in Frage.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="content_container">
                                    <div className="inner">
                                        <div className="image_box">
                                            <Image
                                                src={`https://techno-images.s3.eu-central-1.amazonaws.com/standort-images/${markenStandort.gesellschafterNr}/${markenStandort.standortNr}/Matrix2.jpg`}
                                                alt="Festpreise bei AUTOTEILE PLUS SERVICE"
                                                
                                            />
                                        </div>
                                        <div className="text_box">
                                            <div className="text_inner">
                                                <p>
                                                    <strong>
                                                        IHR PLUS AN VERLÄSSLICHKEIT:
                                                        <br />
                                                        UNSERE FESTPREISE.
                                                    </strong>
                                                    <br />
                                                    <br />
                                                    Egal ob Wartung, Inspektion, HU-Termin oder der Einbau eines von Ihnen bestellten
                                                    Ersatzteils oder Zubehörs: Bei <strong>AUTOTEILE PLUS SERVICE</strong> müssen Sie in Sachen Kosten
                                                    hinterher niemals mit unangenehmen Überraschungen rechnen. Der vorher online vereinbarte
                                                    Fest- oder Paketpreis ist 100%ig bindend.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="content_container">
                                    <div className="inner">
                                        <div className="image_box">
                                            <Image
                                                src={`https://techno-images.s3.eu-central-1.amazonaws.com/standort-images/${markenStandort.gesellschafterNr}/${markenStandort.standortNr}/Matrix3.jpg`}
                                                alt="Qualitätsstandards bei AUTOTEILE PLUS SERVICE"
                                                
                                            />
                                        </div>
                                        <div className="text_box">
                                            <div className="text_inner">
                                                <p>
                                                    <strong>
                                                        IHR PLUS AN VERTRAUEN:
                                                        <br />
                                                        UNSERE QUALITÄTSTANDARDS.
                                                    </strong>
                                                    <br />
                                                    <br />
                                                    Welche Experten Sie bei <strong>AUTOTEILE PLUS SERVICE</strong> für Ihr Fahrzeug benötigen: Sie
                                                    können sich sicher sein, dass sich Ihr Fahrzeug in absolut kompetenten Händen befindet.
                                                    Schließlich handelt es sich dabei garantiert um eines von Deutschlands führenden
                                                    Autohäusern, dessen angeschlossene Markenwerkstatt sich ausschließlich auf die jeweils
                                                    geführten Fahrzeughersteller und -modelle spezialisiert hat.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="content_container">
                                    <div className="inner">
                                        <div className="image_box">
                                            <Image
                                                src={`https://techno-images.s3.eu-central-1.amazonaws.com/standort-images/${markenStandort.gesellschafterNr}/${markenStandort.standortNr}/Matrix4.jpg`}
                                                alt="Sicherheitsstandards bei AUTOTEILE PLUS SERVICE"
                                                
                                            />
                                        </div>
                                        <div className="text_box">
                                            <div className="text_inner">
                                                <p>
                                                    <strong>
                                                        IHR PLUS AN SICHERHEIT:
                                                        <br />
                                                        UNSER BLICK AUFS GANZE.
                                                    </strong>
                                                    <br />
                                                    <br />
                                                    Es gibt nur wenige Teile und Komponenten, die es bei
                                                    <strong>AUTOTEILE PLUS SERVICE</strong> nicht gibt. Und wenn, dann aus gutem Grund. So verkaufen
                                                    wir zum Beispiel keine sicherheitsrelevanten Komponenten wie Bremsscheiben oder
                                                    Achsmanschetten einzeln, sondern nur in Verbindung mit der entsprechenden
                                                    Service-Leistung in einer unserer Markenwerkstätten. Für ein Höchstmaß Sicherheit.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="content_container" id="zubehoerauswahl">
                                    <div className="inner">
                                        <div className="image_box">
                                            <Image
                                                src={`https://techno-images.s3.eu-central-1.amazonaws.com/standort-images/${markenStandort.gesellschafterNr}/${markenStandort.standortNr}/Matrix5.jpg`}
                                                alt="Zubehör-Sortiment bei AUTOTEILE PLUS SERVICE"
                                                
                                            />
                                        </div>
                                        <div className="text_box">
                                            <div className="text_inner">
                                                <p>
                                                    <strong>
                                                        IHR PLUS AN VIELFALT:
                                                        <br />
                                                        UNSER BREITES ZUBEHÖR-SORTIMENT
                                                    </strong>
                                                    <br />
                                                    <br />
                                                    Reifen, Felgen, Kindersitze oder Dachbox, Navi oder Marderabwehr - unser umfangreiches
                                                    Sortiment lässt kaum einen Wunsch rund um Ihr Auto unerfüllt. Das Beste dabei: bei{' '}
                                                    <strong>AUTOTEILE PLUS SERVICE</strong>
                                                    können Sie sich jederzeit auf das Know-How und die Empfehlung einer, auf Ihr Auto
                                                    spezialisierten Markenwerkstatt verlassen. <br />
                                                    <br /> Kurz: überzeugendes Sortiment, zuverlässige Montage und freundlicher Service -
                                                    alles aus einer Hand.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="content_container" id="infografik">
                                    <div className="inner">
                                        <div className="image_box">
                                            <div className="infografik">
                                                <Image
                                                    alt="Infografik Teaser zu AUTOTEILE PLUS SERVICE"
                                                    src="http://techno-images.s3.eu-central-1.amazonaws.com/images/UeberUns/Infografik-Teaser.jpg"
                                                    
                                                />
                                                <Button onClick={() => setModalOpen(true)} ariaLabel="Infografik Modal öffnen">
                                                    zur infografik
                                                </Button>

                                                <Modal
                                                    isOpen={modalOpen}
                                                    onRequestClose={() => setModalOpen(false)}
                                                    contentLabel="Infografik"
                                                >
                                                    <Button
                                                        className="uk-modal-close modalInfografik_button uk-position-top-right"
                                                        type="button"
                                                        onClick={() => setModalOpen(false)}
                                                        ariaLabel="Modal schließen"
                                                    >
                                                        <i className="fa fa-2x fa-times" aria-hidden="true" />
                                                    </Button>
                                                    <Image
                                                        className="uk-width-1-1"
                                                        src="http://techno-images.s3.eu-central-1.amazonaws.com/images/UeberUns/Infografik.jpg"
                                                        alt="Infografik zu AUTOTEILE PLUS SERVICE"
                                                    />
                                                </Modal>
                                            </div>
                                        </div>
                                        <div className="text_box">
                                            <div className="text_inner">
                                                <p>
                                                    Bei <strong>AUTOTEILE PLUS SERVICE</strong>
                                                    &nbsp;profitieren Sie immer von Fullservice: <br />
                                                    <br />
                                                    Online stehen wir 24 Stunden an 365 Tagen im Jahr zu Ihrer Verfügung. Vor Ort sind wir
                                                    bundesweit und markenübergreifend in 1.800 Autohäusern für Sie da. Immer mit bester
                                                    Qualität, hoher Teileverfügbarkeit, sicherer Bezahlung sowie kurzen Lieferzeiten.
                                                    <br />
                                                    <br />
                                                    Bestellen Sie online Ihr gewünschtes Autozubehör oder reservieren Sie das benötigte
                                                    Ersatzteil und vereinbaren Sie Termine für Service, Reparatur oder Einbau in einer
                                                    unserer Fachwerkstätten. Mithilfe Ihrer Automarke und Postleitzahl ermitteln wir für Sie
                                                    eine Auswahl von zertifizierten Autohäusern in Ihrer Nähe.
                                                    <br />
                                                    <br />
                                                    Sollten sich in Ihrer Region keine passende Niederlassung befinden, suchen wir
                                                    automatisch im erweiterten Umkreis, sodass Ihnen immer die nächsten Autowerkstätten
                                                    Ihrer Marke angezeigt werden.
                                                    <br />
                                                    <br />
                                                    Wählen Sie ganz bequem nur noch Ihre gewünschte Fachwerkstatt und Ihren benötigten
                                                    Service aus. Unsere Autohaus-Partner beraten Sie umfassend und kompetent online,
                                                    telefonisch und vor Ort.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </LegacyShopWrapper>
            {markenStandort.isTechno && (
                <section className="uk-section uk-section-default uk-section-small">
                    <div className="uk-container">
                        <ServiceStationFinder />
                    </div>
                </section>
            )}
        </>
    );
}

export default UeberUnsOldFashion;
